// import logo from "../images/logo-planet.png";
import estenzo from "../images/Faculty/estenzo.png";
import cagampang from "../images/Faculty/cagampang.png";
import sieras from "../images/Faculty/sieras.png";
import telen from "../images/Faculty/telen.png";
import dacay from "../images/Faculty/dacay.png";
import bergado from "../images/Faculty/bergado.png";
import garrucha from "../images/Faculty/garrucha.png";
import nalupa from "../images/Faculty/nalupa.png";
import fernandez from "../images/Faculty/fernandez.png";
import mabulay from "../images/Faculty/mabulay.png";
import jementiza from "../images/Faculty/jementiza.png";
import oche from "../images/Faculty/oche.png";


// eslint-disable-next-line import/no-anonymous-default-export
export default [estenzo,cagampang,sieras,telen,dacay,bergado,garrucha,nalupa,fernandez,mabulay,jementiza,oche]